import './dealer-locator-teaser.scss';

document.addEventListener('DOMContentLoaded', () => {
    const $$numberInputs = document.querySelectorAll('[data-numbers-only]');

    $$numberInputs.forEach($input => {
        $input.addEventListener('input', (e) => {
            handleInput(e.target);
        });

        $input.addEventListener('paste', (e) => {
            setTimeout(() => {
                handleInput(e.target);
            }, 1);
        });
    });

    function handleInput($inputElement) {
        const currentValue = $inputElement.value;
        const cleanValue = currentValue.replace(/[^0-9]/g, '');

        if (currentValue !== cleanValue) {
            $inputElement.value = cleanValue;
        }
    }
});
